export const initSubSettings = (column) => {
    column.getElement().querySelectorAll('.ac-column-setting--filter,.ac-column-setting--sort,.ac-column-setting--edit').forEach(setting => {
        new SubsettingSetting(setting);
    });
};
class SubsettingSetting {
    constructor(element) {
        this.element = element;
        this.inputs = element.querySelectorAll('.ac-setting-input input[type="radio"]');
        this.subFields = element.querySelectorAll('.ac-column-setting');
        this.initState();
        this.initEvents();
    }
    initEvents() {
        this.inputs.forEach(el => {
            el.addEventListener('change', () => this.initState());
        });
    }
    initState() {
        this.isOptionEnabled()
            ? this.subFields.forEach(el => el.style.display = 'table')
            : this.subFields.forEach(el => el.style.display = 'none');
    }
    isOptionEnabled() {
        let checked = Array.from(this.inputs).filter(input => {
            return input.checked;
        });
        return checked.length ? checked[0].value === 'on' : false;
    }
}
